<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("WEEKLY_REPORTS.ADD_WEEKLY_REPORT") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button @click="goBack" type="button" class="btn btn-sm btn-primary">
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <weekly-report-form
              :loading="loading"
              :weeklyReportData="weeklyReport"
              :formErrors="formErrors"
              @weeklyReportSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import moment from "moment";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultWeeklyReport from "./defaultWeeklyReport";
import WeeklyReportForm from "./partials/WeeklyReportForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    WeeklyReportForm,
  },

  mixins: [alertLeave],

  data() {
    const weeklyReport = cloneDeep(defaultWeeklyReport);
    return {
      weeklyReport: weeklyReport,
      formErrors: null,
      loading: false,
    };
  },

  methods: {
    goBack() {
      this.$router.push({ name: "List WeeklyReports" });
    },

    viewWeeklyReport(weeklyReport) {
      this.alertLeave = false;
      this.$router.push({
        name: "View WeeklyReport",
        params: { id: weeklyReport.id },
      });
    },

    async editWeeklyReport(weeklyReport) {
      this.alertLeave = false;
      this.$router.push({
        name: "Edit WeeklyReport",
        params: { id: weeklyReport.id },
      });
    },

    async handleSubmit(weeklyReport) {
      this.loading = true;
      const weeklyReportData = cloneDeep(weeklyReport);

      // Normalise les dates : flatpickr (dateFormat 'Y-m-d') écrit le v-model
      // en chaîne locale sans fuseau ; on les clamp à début/fin de journée
      // en heure locale avant de les convertir en UTC pour éviter tout
      // décalage d'un jour au round-trip avec le backend.
      if (weeklyReportData.starts_at) {
        weeklyReportData.starts_at = moment(weeklyReportData.starts_at)
          .startOf("day")
          .toISOString();
      }
      if (weeklyReportData.ends_at) {
        weeklyReportData.ends_at = moment(weeklyReportData.ends_at)
          .endOf("day")
          .toISOString();
      }

      if (weeklyReportData.cafeteria) {
        if (!weeklyReportData.cafeteria.id) {
          delete weeklyReportData.cafeteria;
        }
      }
      if (weeklyReportData.serviceCenter) {
        if (!weeklyReportData.serviceCenter.id) {
          delete weeklyReportData.serviceCenter;
        }
      }
      if (weeklyReportData.establishment) {
        if (!weeklyReportData.establishment.id) {
          delete weeklyReportData.establishment;
        }
      }
      if (weeklyReportData.cafeteria) {
        if (!weeklyReportData.cafeteria.id) {
          delete weeklyReportData.cafeteria;
        }
      }

      try {
        await this.$store.dispatch("weeklyReports/add", weeklyReportData);
        this.$notify({
          type: "success",
          message: this.$t("WEEKLY_REPORTS.WEEKLY_REPORT_ADDED"),
        });
        const weeklyReport = await this.$store.getters["weeklyReports/weeklyReport"];
        this.viewWeeklyReport(weeklyReport);
        this.loading = false;
      } catch (error) {
        const errors = error.response?.data?.errors || [];
        // Show the business reason when the API gives a known code (e.g. an
        // establishment that does no weekly report), the generic message otherwise.
        const known = errors.find((err) => err.detail && this.$te(`ERRORS.${err.detail}`));
        this.$notify({
          type: "danger",
          message: known
            ? this.$t(`ERRORS.${known.detail}`)
            : this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = errors;
        // A refused creation creates nothing. The store still holds the last
        // report viewed in this session: it used to be deleted right here.
        this.loading = false;
      }
    },
  },
};
</script>
